/**
 * High-level Auth-Logik: Login, Register, Logout, Bootstrap.
 * Nutzt die Endpunkte + den Session-Speicher. Die Erstregistrierung laeuft
 * bewusst im Web/Desktop; die App zeigt dafuer nur Hinweise im Login.
 */
import { signal } from "@preact/signals";
import { endpoints, type RegisterPayload } from "../api/endpoints";
import { clearSession, getToken, setSession, setUser } from "./session";

/** Wird beim App-Start gesetzt, solange /api/me noch läuft. */
export const authBootstrapping = signal<boolean>(true);

export async function login(email: string, password: string): Promise<void> {
  const res = await endpoints.login(email.trim().toLowerCase(), password);
  setSession(res.token ?? res.access_token, res.user);
}

export async function register(payload: RegisterPayload): Promise<void> {
  const res = await endpoints.register(payload);
  setSession(res.token ?? res.access_token, res.user);
}

export async function logout(): Promise<void> {
  const token = getToken();
  try {
    if (token) await endpoints.logout(token);
  } catch {
    /* Best-effort: lokale Session in jedem Fall verwerfen. */
  } finally {
    clearSession();
  }
}

/**
 * Beim App-Start: vorhandenen Token gegen /api/me prüfen und Nutzer
 * auffrischen. 401/403 verwirft die Session im Client automatisch.
 */
export async function bootstrap(): Promise<void> {
  authBootstrapping.value = true;
  try {
    if (getToken()) {
      const res = await endpoints.me();
      if (res?.user) setUser(res.user);
    }
  } catch {
    /* Client hat bei 401/403 bereits aufgeräumt. */
  } finally {
    authBootstrapping.value = false;
  }
}
